import React from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl } from 'react-intl';

import Swiper from '@components/Swiper';
import ProductItem from '@components/ProductItem';
import { IMAGE_SIZE } from '@services/images/constants';
import ClientComponents from '@components/ClientComponents';
import HighlightedProductDetails from '@conversion/components/HighlightedProductDetails';
import ProductCardContainer, {
  getProductCardProps,
} from '@results/HOCs/ProductCardContainer';
import SwimlaneCardContainer from '@results/HOCs/SwimlaneCardContainer';
import Tag from '@components/Tag';
import { Success } from '@components/Icons';
import { SWIMLANES } from '@shopDetails/constants';
import TagContainer from './components/TagContainer';
import LateralSpace from './components/LateralSpace';
import Subtitle from './components/Subtitle';

import messages from './messages';

export class HighlightedProducts extends React.PureComponent {
  static propTypes = {
    products: PropTypes.array.isRequired,
    position: PropTypes.number,
    countryCode: PropTypes.string.isRequired,
    intl: intlShape,
    onBeforeProductConfig: PropTypes.func.isRequired,
    trackSwimlane: PropTypes.func.isRequired,
    trackSwimlaneSwiped: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.handleOnScrollFinish = this.handleOnScrollFinish.bind(this);
  }

  componentDidMount() {
    const { products, trackSwimlane, position } = this.props;
    if (products.length > 0) {
      trackSwimlane(products, SWIMLANES.RECOMMENDED_PRODUCTS, position);
    }
  }

  handleOnScrollFinish(currentIndex) {
    const { trackSwimlaneSwiped, products } = this.props;
    trackSwimlaneSwiped({
      title: SWIMLANES.RECOMMENDED_PRODUCTS,
      type: 'product',
      screenType: 'shop_details',
      position: currentIndex,
      products,
    });
  }

  getProducts(isFullWidth = false) {
    const {
      products,
      countryCode,
      onBeforeProductConfig,
      position,
    } = this.props;

    return (
      <ClientComponents>
        <Swiper id="highlighted" onScrollFinish={this.handleOnScrollFinish}>
          {products.map((product, idx) => (
            <ProductCardContainer
              key={product.id}
              {...getProductCardProps(product)}
              onBeforeProductConfig={onBeforeProductConfig}
            >
              {onProductClick => (
                <SwimlaneCardContainer
                  onClick={onProductClick}
                  swimlane={{ code: SWIMLANES.RECOMMENDED_PRODUCTS }}
                  swimlanePosition={position}
                  item={product}
                  positionItem={idx}
                >
                  {onClick => (
                    <ProductItem
                      product={product}
                      countryCode={countryCode}
                      size={isFullWidth ? IMAGE_SIZE.BIG : IMAGE_SIZE.MEDIUM}
                      onClick={onClick}
                      menuSection={`widget_${SWIMLANES.RECOMMENDED_PRODUCTS}`}
                    >
                      <HighlightedProductDetails
                        product={product}
                        showDescription
                      />
                    </ProductItem>
                  )}
                </SwimlaneCardContainer>
              )}
            </ProductCardContainer>
          ))}
        </Swiper>
      </ClientComponents>
    );
  }

  render() {
    const { products, intl } = this.props;
    if (products.length === 0) return null;

    const hasOneProduct = products.length === 1;

    return (
      <div>
        <LateralSpace>
          <Subtitle
            label={intl.formatMessage(messages.title)}
            separator={false}
          />
          <TagContainer>
            <Tag
              text={intl.formatMessage(messages.photos)}
              icon={<Success size="xsmall" />}
              rounded
            />
          </TagContainer>
        </LateralSpace>
        {this.getProducts(!!hasOneProduct)}
      </div>
    );
  }
}

export default injectIntl(HighlightedProducts);
